import { slicedToArray as _slicedToArray, toConsumableArray as _toConsumableArray } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import { Menu, MenuButton, Button, MenuList, MenuOptionGroup, MenuDivider, MenuGroup } from '@chakra-ui/react';
import React, { useState } from 'react';
import { MenuItem } from './menu-item.js';

var DropdownMenu = function DropdownMenu(_ref) {
  var menuButton = _ref.menuButton,
      menuButtonText = _ref.menuButtonText,
      menuButtonIcon = _ref.menuButtonIcon,
      menuButtonRightIcon = _ref.menuButtonRightIcon,
      _ref$groups = _ref.groups,
      groups = _ref$groups === void 0 ? [] : _ref$groups,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? 'bottom-start' : _ref$placement,
      _ref$isMenuItemOption = _ref.isMenuItemOptions,
      isMenuItemOptions = _ref$isMenuItemOption === void 0 ? false : _ref$isMenuItemOption;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      subMenuSelections = _useState2[0],
      setSubMenuSelections = _useState2[1];

  var checkboxChange = function checkboxChange(e) {
    var value = e.target.value;

    var updatedArr = _toConsumableArray(subMenuSelections);

    if (!updatedArr.includes(value)) {
      updatedArr.push(value);
    } else {
      updatedArr = updatedArr.filter(function (item) {
        return item !== value;
      });
    }

    setSubMenuSelections(updatedArr);
  };

  var menuItems = function menuItems(items) {
    return items.map(function (item, index) {
      var _item$items;

      var key = "".concat(item.text, "-").concat(item.value, "-").concat(index);
      var count = (_item$items = item.items) === null || _item$items === void 0 ? void 0 : _item$items.filter(function (item) {
        return item.value && subMenuSelections.includes(item.value);
      }).length;
      return /*#__PURE__*/React.createElement(MenuItem, {
        key: key,
        item: item,
        isMenuItemOptions: isMenuItemOptions,
        setSubMenuSelections: setSubMenuSelections,
        checkboxChange: checkboxChange,
        selectionCount: count
      });
    });
  };

  var menuGroups = function menuGroups(groups) {
    return groups.map(function (group, index) {
      var key = "".concat(group.groupTitle, "-").concat(index);

      if (isMenuItemOptions) {
        return /*#__PURE__*/React.createElement("div", {
          key: key
        }, /*#__PURE__*/React.createElement(MenuOptionGroup, {
          key: key,
          title: group.groupTitle,
          type: group.menuGroupOptionType,
          defaultValue: group.defaultValue
        }, menuItems(group.items)), !!group.hasDivider && /*#__PURE__*/React.createElement(MenuDivider, null));
      }

      return /*#__PURE__*/React.createElement("div", {
        key: key
      }, /*#__PURE__*/React.createElement(MenuGroup, {
        title: group.groupTitle
      }, menuItems(group.items)), !!group.hasDivider && /*#__PURE__*/React.createElement(MenuDivider, null));
    });
  };
  /**
   * DOM
   */


  return /*#__PURE__*/React.createElement(Menu, {
    "data-object-type": "core-dropdown-menu",
    placement: placement,
    closeOnSelect: !isMenuItemOptions
  }, menuButton || /*#__PURE__*/React.createElement(MenuButton, {
    as: Button,
    rightIcon: menuButtonRightIcon,
    "data-object-type": "core-dropdown-menu-button"
  }, !!menuButtonText && /*#__PURE__*/React.createElement(React.Fragment, null, menuButtonText), !!menuButtonIcon && /*#__PURE__*/React.createElement(React.Fragment, null, menuButtonIcon)), /*#__PURE__*/React.createElement(MenuList, {
    "data-object-type": "core-dropdown-menu-list"
  }, !!items && menuItems(items), !!groups && menuGroups(groups)));
};

DropdownMenu.displayName = "DropdownMenu";
export { DropdownMenu };